import LoginPanel from '~/components/panels/LoginPanel.vue';
import PasswordRecover from '~/components/panels/PasswordRecoverPanel.vue';
import Registration from '~/components/panels/RegisterPanel.vue';
export default {
  components: {
    LoginPanel: LoginPanel,
    PasswordRecover: PasswordRecover,
    Registration: Registration
  },
  computed: {
    authPanelStore: function authPanelStore() {
      return useAuthPanelStore();
    },
    state: function state() {
      return this.authPanelStore.state;
    },
    direction: function direction() {
      return this.authPanelStore.direction;
    }
  }
};